import { BasePaymentToken } from '../type';

/**
 * Masks a credit card number by replacing the middle digits with "**** ****".
 *
 * @param cardNumber - The full card number as a string.
 * @returns The masked card number as a string in the format "4111 **** **** 1111".
 * If the card number is not 16 digits long, it returns the original card number.
 */
export const maskCardNumber = (cardNumber: string): string => {
	if (!cardNumber) return cardNumber;
	return `${cardNumber.slice(0, 4)} **** **** ${cardNumber.slice(-4)}`;
};

/**
 * Retrieves the first token from an array of tokens.
 *
 * @template T - A type that extends the BasePaymentToken interface.
 * @param {T[]} tokens - An array of tokens from which to retrieve the first token.
 * @returns {T | undefined} - The first token found in the array, or undefined if no tokens are found.
 */
export function getFirstToken<T extends BasePaymentToken>(tokens: T[]): T | undefined {
	return tokens.find((token) => token);
}
